import { Stack, type StackProps, useTheme } from "@mui/material";
import type { FC } from "react";
import { InspirationStageRow } from "web_myplann/Inspiration/Components/InspirationStageRow";
import type { InspirationStage } from "web_myplann/Inspiration/Types/InspirationTypes";

type Props = Omit<StackProps, "gap" | "children"> & {
	stages: InspirationStage[];
};

export const InspirationStageList: FC<Props> = ({ stages, ...stackProps }) => {
	const theme = useTheme();

	return (
		<Stack gap={theme.spacingTokens.xsm} {...stackProps}>
			{stages.map((stage) => (
				<InspirationStageRow
					key={stage.label}
					label={stage.label}
					note={stage.note}
					value={stage.value}
				/>
			))}
		</Stack>
	);
};
